import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  mode: "history",
  routes: [
    //  首页
    {
      path: "/",
      name: "Homepage",
      component: () => import("@/view/homePage")
    },
    //  首页
    {
      path: "//",
      name: "Homepage",
      component: () => import("@/view/homePage")
    },
    //  游戏中心
    {
      path: "/gameCenter",
      name: "GameCenter",
      component: () => import("@/view/gameCenter")
    },
    //  搜索页面
    {
      path: "/search",
      name: "Search",
      component: () => import("@/details/search")
    },
    //  游戏详情
    {
      path: "/gameDetails",
      name: "GameDetails",
      component: () => import("@/details/gameDetails")
    },
    // //  游戏详情
    // {
    //   path: "/TryitNow",
    //   name: "TryitNow",
    //   component: () => import("@/details/TryitNow")
    // },
    //  H5
    {
      path: "/Hfive",
      name: "Hfive",
      component: () => import("@/view/Hfive")
    },
    //  今日开服
    {
      path: "/openService",
      name: "OpenService",
      component: () => import("@/view/openService")
    },
    //  排行榜单
    {
      path: "/rankingList",
      name: "RankingList",
      component: () => import("@/view/rankingList")
    },
    // 礼包中心
    {
      path: "/giftBag",
      name: "GiftBag",
      component: () => import("@/view/giftBag")
    },
    //  礼包详情
    {
      path: "/giftBagDetails",
      name: "GiftBagDetailsw",
      component: () => import("@/details/giftBagDetails")
    },
    ,
    // {
    //     path: '/giftBagDetailstwo',
    //     name: 'GiftBagDetails',
    //     component: ()=>import("@/details/giftBagDetailstwo")
    //   }
    //  资讯
    {
      path: "/realInfo",
      name: "RealInfo",
      component: () => import("@/view/realInfo")
    },
    //  资讯詳情
    {
      path: "/informationDetails",
      name: "InformationDetails",
      component: () => import("@/details/InformationDetails")
    },
    //  客服中心
    {
      path: "/customer",
      name: "Customer",
      component: () => import("@/view/customer")
    },
    //  客服详情
    {
      path: "/customerDetails",
      name: "customerDetails",
      component: () => import("@/details/customerDetails")
    },
    //  app下载
    {
      path: "/appdown",
      name: "appdown",
      component: () => import("@/details/appDown")
    },
    //  404
    {
      path: "/404",
      name: "404",
      component: () => import("@/view/404")
    },
    //  404
    {
      path: "/405",
      name: "405",
      component: () => import("@/view/405")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js